import { IRetailerLinkCohortEnum } from "@faire/web-api--source/indigofair/retailers/pos/IRetailerLinkCohortEnum";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
import type { JSX } from "react";

export const getBannerInfoByCohort = (
  retailerLinkCohort: IRetailerLinkCohortEnum.RetailerLinkCohort,
  posCompanyName: string
): IPOSCohortBannerInfo | undefined => {
  switch (retailerLinkCohort) {
    case IRetailerLinkCohortEnum.RetailerLinkCohort.NEW:
      return {
        message: (
          <StrictLocalMsg
            defaultMessage="Faire connects seamlessly with your store's POS system"
            description={{
              text: "Banner message prompting retailers to connect their POS system to Faire",
              img: "https://cdn.faire.com/fastly/adbe38ec3d1dea9a012b90fb75981d06f05570c8cc2ed24d7a40cdfd00087888.png",
            }}
          />
        ),
        buttonLabel: (
          <StrictLocalMsg
            defaultMessage="Learn more"
            description={{
              text: "Learn more CTA text",
              img: "https://cdn.faire.com/fastly/adbe38ec3d1dea9a012b90fb75981d06f05570c8cc2ed24d7a40cdfd00087888.png",
            }}
          />
        ),
      };
    case IRetailerLinkCohortEnum.RetailerLinkCohort.CHURNED:
      return {
        message: (
          <StrictLocalMsg
            defaultMessage="Try our new & improved POS integrations"
            description={{
              text: "Banner message prompting churned retailers to re-connect their POS system to Faire",
              img: "https://cdn.faire.com/fastly/67f22cd34009a260b6f437fc97812c793b51f9e015ea600705939b46b909c896.png",
            }}
          />
        ),
        buttonLabel: (
          <StrictLocalMsg
            defaultMessage="Learn more"
            description={{
              text: "Learn more CTA text",
              img: "https://cdn.faire.com/fastly/adbe38ec3d1dea9a012b90fb75981d06f05570c8cc2ed24d7a40cdfd00087888.png",
            }}
          />
        ),
      };
    case IRetailerLinkCohortEnum.RetailerLinkCohort.INACTIVE:
      return {
        message: (
          <StrictLocalMsg
            defaultMessage="Check out our new & improved {posCompanyName} integration"
            description={{
              text: "Banner message prompting inactive connected retailers to check out the latest POS improvements",
              img: "https://cdn.faire.com/fastly/e46d1782b0ec7b29666211dffc14dc3c9e472d6267537df4859c5e11abfa9789.png",
            }}
            values={{ posCompanyName }}
          />
        ),
        buttonLabel: (
          <StrictLocalMsg
            defaultMessage="View POS integration"
            description={{
              text: "View POS integration CTA text",
              img: "https://cdn.faire.com/fastly/e46d1782b0ec7b29666211dffc14dc3c9e472d6267537df4859c5e11abfa9789.png",
            }}
          />
        ),
      };
    default:
      return undefined;
  }
};

interface IPOSCohortBannerInfo {
  message: JSX.Element;
  buttonLabel: JSX.Element;
}
